<template>
  <div class="client-context-layout">
    <NavBar />
    <div class="dashboard-layout">
      <ClientActionsDrawer :activeMenu="activeMenu" :client="client" />
      <main class="main-content">
        <div class="context-header">
          <button class="back-btn" @click="goBackToAdmin">
            <i class="fas fa-arrow-left"></i> Back to Admin
          </button>
          <h2 class="client-name">{{ client?.name || "Client" }}</h2>
        </div>
        <div v-if="loading" class="loading-state">
          <i class="fas fa-spinner fa-spin"></i>
          <p>Loading client data...</p>
        </div>
        <router-view v-else v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" :client="client" />
          </keep-alive>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import ClientActionsDrawer from "@/components/admin/ClientActionsDrawer.vue";
import store from "@/store";

export default {
  name: "ClientContextLayout",
  components: {
    NavBar,
    ClientActionsDrawer,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    client() {
      return store.getters.getSelectedClient;
    },
    activeMenu() {
      // Extract the active menu from the route
      const path = this.$route.path;
      const pathParts = path.split("/");
      const lastPart = pathParts[pathParts.length - 1];

      // Check if the last part is a valid menu item
      const menuItems = [
        "overview",
        "goals-summary",
        "planning",
        "sip",
        "goals",
        "documents",
        "transactions",
        "assets",
        "allocations",
      ];
      if (menuItems.includes(lastPart)) {
        return lastPart;
      }

      // Default to overview if we're at the root client details route
      return "overview";
    },
  },
  methods: {
    goBackToAdmin() {
      this.$router.push("/admin/clients");
    },
  },
  created() {
    // If no client is selected, try to fetch it by ID
    if (!this.client) {
      const clientId = this.$route.params.id;

      // Redirect to clients list if no ID
      if (!clientId) {
        this.$router.push("/admin/clients");
        return;
      }

      // Try to find client in store
      const clients = store.getters.getClients;
      const client = clients.find((c) => c.CID === clientId);

      if (client) {
        store.commit("setSelectedClient", client);
        this.loading = false;
      } else {
        // Try to fetch clients first
        store.dispatch("fetchClients").then(() => {
          const refreshedClients = store.getters.getClients;
          const refreshedClient = refreshedClients.find(
            (c) => c.CID === clientId
          );

          if (refreshedClient) {
            store.commit("setSelectedClient", refreshedClient);
          } else {
            // If still not found, redirect
            this.$router.push("/admin/clients");
          }
          this.loading = false;
        });
      }
    } else {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.client-context-layout {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.dashboard-layout {
  display: flex;
  min-height: calc(100vh - 80px); /* Adjust for navbar height */
}

.main-content {
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
}

.context-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #f1f3f5;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #495057;
  transition: background-color 0.3s;
}

.back-btn:hover {
  background-color: #e9ecef;
}

.client-name {
  font-size: 1.5rem;
  color: #072ac8;
  margin: 0;
}

@media (max-width: 768px) {
  .dashboard-layout {
    flex-direction: column;
  }

  .context-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #666;
  text-align: center;
}

.loading-state i {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #3498db;
}
</style>
